import { render, staticRenderFns } from "./detals.vue?vue&type=template&id=6dc43128&"
import script from "./detals.vue?vue&type=script&lang=js&"
export * from "./detals.vue?vue&type=script&lang=js&"
import style0 from "./detals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports